import Radio from 'components/shared/inputs/radio/RadioInput';
import styled from 'styled-components';

const StyledRadio = styled(Radio)`
    grid-area: 'radio';
`;

export default StyledRadio;
